import React, { Fragment, useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import "../Header/SubHeader.css";

const SubHeader = () => {
  const location = useLocation();
  const path = location.pathname;
  const detailClassName = path.split("/", 3);
  const [className, setClassName] = useState("");

  //View 페이지 헤더메세지
  useEffect(() => {
    setClassName(path.substr(1));
    if (detailClassName[2] === "detail") {
      setClassName(detailClassName[1]);
    }
  }, [path]);

  if (path === "/") {
    return null;
  }

  let twerking;

  switch (path) {
    case "/about":
      twerking = "COMPANY";
      break;
    case "/ceo":
      twerking = "COMPANY";
      break;
    case "/vision":
      twerking = "COMPANY";
      break;
    case "/coretech":
      twerking = "COMPANY";
      break;
    case "/project":
      twerking = "RESEARCH";
      break;
    case "/publications":
      twerking = "RESEARCH";
      break;
    case "/patents":
      twerking = "RESEARCH";
      break;

    default:
      break;
  }
  let subtwerking;
  switch (twerking) {
    case "COMPANY":
      subtwerking = [
        { idx: 1, name: "About" },
        { idx: 2, name: "CEO profile" },
        { idx: 3, name: "Vision" },
        { idx: 4, name: "Technology" },
      ];
      break;
    case "RESEARCH":
      subtwerking = [
        { idx: 1, name: "Project" },
        { idx: 2, name: "Publications" },
        { idx: 3, name: "Patents" },
      ];
      break;
    default:
      subtwerking = [];
      break;
  }

  let headerText = "";
  let menuText_1 = "";
  let menuLink = "";

  switch (className) {
    case "coretech":
      break;
    case "news":
      headerText = "News";
      menuText_1 = "News";
      menuLink = "/news";
      break;
    case `news/detail`:
      headerText = "News";
      menuText_1 = "News";
      menuLink = "/news";
      break;
    case "contact":
      headerText = "Contact";
      menuText_1 = "Contact Us";
      menuLink = "/contact";
      break;
    default:
      headerText = "";
      menuText_1 = "";
  }
  const SUBJECT = () => {
    return (
      <div className="sub-menu">
        {subtwerking.length > 0 && (
          <Link
            to={twerking === "COMPANY" ? "/about" : "/project"}
            className={`link_text ${
              className === "project" || className === "about" ? "active" : ""
            }`}
          >
            {subtwerking[0].name}
          </Link>
        )}
        {subtwerking.length > 1 && (
          <Link
            to={twerking === "COMPANY" ? "/ceo" : "/publications"}
            className={`link_text ${
              className === "publications" || className === "ceo"
                ? "active"
                : ""
            }`}
          >
            {subtwerking[1].name}
          </Link>
        )}
        {subtwerking.length > 2 && (
          <Link
            to={twerking === "COMPANY" ? "/vision" : "/patents"}
            className={`link_text ${
              className === "patents" || className === "vision" ? "active" : ""
            }`}
          >
            {subtwerking[2].name}
          </Link>
        )}
        {subtwerking.length > 3 || className === "coretech" ? (
          <Link
            to="/coretech"
            className={`link_text ${className === "coretech" && "active"}`}
          >
            Technology
          </Link>
        ) : null}
      </div>
    );
  };
  return (
    <Fragment>
      {className !== "project" &&
      className !== "publications" &&
      className !== "patents" &&
      className !== "about" &&
      className !== "ceo" &&
      className !== "vision" &&
      className !== "coretech" ? (
        <div>
          <div className={`sub-header ${className}`}>
            <div className="sub-bg"></div>
            <h2>{headerText}</h2>
          </div>
          <div className={`sub-menu ${className}`}>
            <Link to={menuLink} className="link_text active">
              {menuText_1}
            </Link>
          </div>
        </div>
      ) : (
        <div>
          <div className="sub-header">
            <div className="sub-bg"></div>
            <h2>{twerking}</h2>
          </div>
          <SUBJECT />
        </div>
      )}
    </Fragment>
  );
};

export default SubHeader;
